package br.com.texeratx.boardgametimeapp.ui.screens.login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import br.com.texeratx.boardgametimeapp.ui.screens.forgot_password.ForgotPasswordScreen
import br.com.texeratx.boardgametimeapp.ui.screens.reset_password.ResetPasswordScreen
import br.com.texeratx.boardgametimeapp.ui.screens.signup.SignupScreen
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.getScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow

class LoginScreen : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel = getScreenModel<LoginViewModel>()
        val state by viewModel.state.collectAsState()

        LoginUI(
            state = state,
            onEmailChange = viewModel::updateEmail,
            onPasswordChange = viewModel::updatePassword,
            onLoginClick = { viewModel.login(navigator) },
            onGoToSignup = { navigator.push(SignupScreen()) },
            onGoToForgotPassword = { navigator.push(ForgotPasswordScreen()) },
            onGoToResetPassword = { navigator.push(ResetPasswordScreen()) }
        )
    }
}
